import { Component, OnInit,Input,EventEmitter,Output, Optional} from '@angular/core';
import{ContentManagementService} from '../../../Services/content-management/content-management.service';
import { AnswerChoiceModel } from 'src/app/Models/AnswerChoiceModel';
import { QuestionStatusModel } from 'src/app/Models/QuestionStatusById';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VAddAnswerChoice } from 'src/app/Validators/Validators';
import { ToastrService } from "ngx-toastr";
import { ChangeDetectorRef } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'app-content-study-unit-subject',
  templateUrl: './content-study-unit-subject.component.html',
  styleUrls: ['./content-study-unit-subject.component.css']
})
export class ContentStudyUnitSubjectComponent implements OnInit {
 @Input() SubjectlistID:any;
 @Input() subjectById:any;
 @Input() StudyUnit:any;
 @Input() headingLabel: string = 'Study Unit Name';
 @Input() headingBgColor: string = 'transparent';
 @Input() showHeaderCloseButton: boolean = false;
 @Output() CloseStudyUnitSubject: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private cdr: ChangeDetectorRef,
    public service:ContentManagementService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    @Optional() public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.getBreadcrumbDetails();
    this.GetSubjectlist(this.SubjectlistID);
  }



 Breadcrumblist:any;
 Breadcrumb:string
 getBreadcrumbDetails() {
  // this.service.getBreadcrumbDetails({ 'ID': this.subjectById.Subject_Id }).subscribe((i: any) => {
  //   this.Breadcrumblist = i;

 this.service.getBreadcrumb({'ID': this.SubjectlistID,'Screenname':'CONTENT_MANAGEMENT'}).subscribe((i:any)=>{

  this.Breadcrumblist = i;
  this.Breadcrumb=this.Breadcrumblist.Data;

  }, error => {  console.log(error) }
  );


 }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  SubjectList:any;
  Subject:any;
  studyunitlist:any;
  GetSubjectlist(data:any){

   this.service.GetStudyUnitSubject({'Study_Unit_Id':data}).subscribe((i:any)=>{
     this.Subject=i;
     this.SubjectList=this.Subject.MasterList;
     let Filterlist = [];
     for(let s of this.SubjectList){
      if(s.Study_Unit_ID==this.SubjectlistID){
        Filterlist.push(s);
      }
     }
     this.studyunitlist=Filterlist;
  //  }).catch((e:any)=>{
  //    this.SubjectList=null;
  //  });
}, error => {  console.log(error) }
);
 }
  Modalpopup:boolean;
  ClosePopup(){
    this.CloseStudyUnitSubject.emit(this.Modalpopup);
    // Only close modal if opened as a modal
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
  }
  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.studyunitlist, event.previousIndex, event.currentIndex);
  }
  Save(){
    console.log(this.studyunitlist);
    const payload = {
      Study_Unit_Id: this.StudyUnit.ID,
      UDTStudyUnitSubject: this.studyunitlist.map((e:any,index:number) => {
        return {
          Display_Order: index+1,
          SubjectId: e.Subject_ID,
          TestingProbabilityTypeCode: e.Testing_Probability_Type_Code,
        };
      }),
    };

    this.service.CreateOrModifyStudyUnitSubject(payload).subscribe((res: any) => {

      if (res.Message == 'Success') {
        this.toastr.success('Display Order Updated Successfully', '', {
          timeOut: ConstantVars.ToastSucessTimeout,
        });
        // Close modal after successful save only if opened as modal
        if (this.activeModal) {
          this.activeModal.close(res);
        }
      } else {
        this.toastr.error(res.Message, '', {
          timeOut: ConstantVars.ToastErrorTimeout,
        });
      }
    });
  }

}
